import store from '@/store';

export default (to, from, next) => ({
  allow: store.getters.is_app_feedback_allowed,
  redirect: { name: 'not-found' },
});
